import _classCallCheck from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/createClass.js";
/**
 *
 * @private
 * @param {any} a
 */
function isObject(a) {
  if (typeof a !== 'object' || a instanceof Array) {
    return false;
  } else {
    return true;
  }
}
var Config = /*#__PURE__*/function () {
  function Config() {
    _classCallCheck(this, Config);
  }
  return _createClass(Config, [{
    key: "filterOutNonSupportedKeys",
    value: function filterOutNonSupportedKeys(userProvidedConfig, validKeys) {
      var obj = Object.create({});
      if (isObject(userProvidedConfig)) {
        Object.keys(userProvidedConfig).forEach(function (key) {
          if (validKeys.indexOf(key) >= 0) {
            obj[key] = userProvidedConfig[key];
          } else {
            console.warn('Warning - unsupported key provided to configuration: ', key);
          }
        });
        return obj;
      } else {
        return Object.create({});
      }
    }
  }]);
}();
export default Config;